import CardSpacer from "@saleor/components/CardSpacer";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";
import Grid from "@saleor/components/Grid";
import PageBackNavigation from "@saleor/components/PageBackNavigation";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import { DiscountErrorFragment } from "@saleor/fragments/types/DiscountErrorFragment";
import useSetBrandOnLoad from "@saleor/products/hooks/useSetBrandOnLoad";
import {
  hasNoError,
  useCreateSalesValidation
} from "@saleor/utils/validators/sales";
import React, { useState } from "react";
import { useIntl } from "react-intl";

import { SaleType as SaleTypeEnum } from "../../../types/globalTypes";
import DiscountDates from "../DiscountDates";
import SaleInfo from "../SaleInfo";
import { SalesKAMSDropdownProps } from "../SaleListPage";
import SalesDescription from "../SalesDescription";
import SaleSellerDropdown from "../SaleSellerDropdown";
import SaleType from "../SaleType";
import SaleValue from "../SaleValue";
export interface FormData {
  brand?: string;
  brandLabel?: string;
  description: string;
  endDate: string;
  endTime: string;
  hasEndDate: boolean;
  name: string;
  startDate: string;
  startTime: string;
  type: SaleTypeEnum;
  value: string;
}
export interface SaleCreatePageProps extends SalesKAMSDropdownProps {
  defaultCurrency: string;
  disabled: boolean;
  errors: DiscountErrorFragment[];
  saveButtonBarState: ConfirmButtonTransitionState;
  onBack: () => void;
  onSubmit: (data: FormData) => void;
}
const SaleCreatePage: React.FC<SaleCreatePageProps> = ({
  defaultCurrency,
  disabled,
  errors,
  onSubmit,
  saveButtonBarState,
  onBack,
  isKAMS,
  brand,
  brandLabel,
  onBrandChange,
  kamsBrands
}) => {
  const intl = useIntl();
  const initialForm: FormData = {
    brand: "",
    description: "",
    endDate: "",
    endTime: "",
    hasEndDate: false,
    name: "",
    startDate: "",
    startTime: "",
    type: SaleTypeEnum.ABSOLUTE_VALUE,
    value: ""
  };

  const initialValidatedForm = {
    description: null,
    endDate: null,
    name: null,
    value: null
  };

  const [clientErrors, setErrorValdiation] = useState(initialValidatedForm);

  const handleSubmit = event => {
    const validate = useCreateSalesValidation(event);
    if (hasNoError(validate)) {
      setErrorValdiation(validate);
      onSubmit(event);
    } else {
      setErrorValdiation(validate);
    }
  };

  const breadcrumbDirectory = [
    {
      name: "Sales",
      url: "/discounts/sales"
    },
    {
      name: "Create Sale"
    }
  ];

  return (
    <Form initial={initialForm} onSubmit={handleSubmit}>
      {({ change, data, hasChanged, submit }) => {
        useSetBrandOnLoad(change, brand);

        return (
          <Container>
            {isKAMS && (
              <SaleSellerDropdown
                brand={brand}
                brandLabel={brandLabel}
                brandChoices={kamsBrands}
                onBrandChange={onBrandChange}
              />
            )}
            <PageBreadcrumbNavigation items={breadcrumbDirectory} />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "10px"
              }}
            >
              <PageBackNavigation onBack={onBack} />
              <PageHeader
                title={intl.formatMessage({
                  defaultMessage: "Create Sale",
                  description: "page header"
                })}
              />
            </div>
            <Grid>
              <div>
                <SaleInfo
                  data={data}
                  disabled={disabled}
                  errors={errors}
                  clientErrors={clientErrors}
                  onChange={change}
                />
                <CardSpacer />
                <SaleType
                  isEdit={false}
                  data={data}
                  disabled={disabled}
                  onChange={change}
                />
                <CardSpacer />
                {data && data.type !== "ABSOLUTE_VALUE" ? (
                  <SaleValue
                    currencySymbol={defaultCurrency}
                    data={data}
                    disabled={disabled}
                    errors={errors}
                    clientErrors={clientErrors}
                    onChange={change}
                  />
                ) : (
                  ""
                )}
                <CardSpacer />
                <SalesDescription
                  data={data}
                  disabled={disabled}
                  errors={errors}
                  clientErrors={clientErrors}
                  onChange={change}
                />
                <CardSpacer />
                <DiscountDates
                  data={data}
                  disabled={disabled}
                  defaultCurrency={defaultCurrency}
                  errors={errors}
                  clientErrors={clientErrors}
                  onChange={change}
                />
              </div>
            </Grid>
            <SaveButtonBar
              disabled={disabled || !hasChanged}
              onCancel={onBack}
              onSave={submit}
              state={saveButtonBarState}
            />
          </Container>
        );
      }}
    </Form>
  );
};
SaleCreatePage.displayName = "SaleCreatePage";
export default SaleCreatePage;
